import request from "superagent";

declare var ApiRouteBase: string;
const apiRoot: string = ApiRouteBase + "/";

/** Response body from GET Resources/PaymentLinks/art-fee/from-token */
export interface ArtFeePaymentLinkFromToken {
    webOrderNumber: string;
    amount: number;
    maxPayableAmount: number;
    customerName: string;
    customerFirstName?: string;
    paymentLinkType: "ArtFee";
    /** Present when API includes link status (Paid, Sent, Cancelled, Expired, …). */
    status?: string;
}

export const fetchArtFeePaymentLinkFromToken = (
    token: string,
    onSuccess: (link: ArtFeePaymentLinkFromToken) => void,
    onError: (error: string) => void
) => {
    request
        .get(`${apiRoot}Resources/PaymentLinks/art-fee/from-token`)
        .set("Authorization", `Bearer ${token}`)
        .end((err, res) => {
            if (err || !res.ok) {
                console.error("fetchArtFeePaymentLinkFromToken: Error fetching payment link", err);
                onError("Invalid or expired payment link.");
                return;
            }

            if (!res.body || !res.body.webOrderNumber) {
                console.warn("fetchArtFeePaymentLinkFromToken: No webOrderNumber returned.");
                onError("Payment link not found.");
                return;
            }

            onSuccess(res.body as ArtFeePaymentLinkFromToken);
        });
};
